import { render } from "./NetPriceAccordion.vue?vue&type=template&id=063cdbda"
import script from "./NetPriceAccordion.vue?vue&type=script&lang=js"
export * from "./NetPriceAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/net-price/NetPriceAccordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "063cdbda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('063cdbda', __exports__)) {
    api.reload('063cdbda', __exports__)
  }
  
  module.hot.accept("./NetPriceAccordion.vue?vue&type=template&id=063cdbda", () => {
    api.rerender('063cdbda', render)
  })

}


export default __exports__